import { useParams } from 'react-router-dom';
import { models } from '../data/models';
import ModelGallery from '../components/ModelPage/ModelGalary';

function ModelPage() {
  const { slug } = useParams();
  const model = models.find((m) => m.slug === slug);

  if (!model) return <h1 className="text-white text-center mt-20">Model not found</h1>;

  return (
    <div className="text-white max-w-7xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold mb-6 text-orange-400">{model.name}</h1>

      {/* Model Viewer */}
      <model-viewer
        src={model.modelFile}
        auto-rotate
        camera-controls
        shadow-intensity="1"
        className="w-full h-[500px] rounded-lg mb-8 bg-black"
      ></model-viewer>

      {/* Photos Section */}
      {model.photos?.length > 0 && (
        <div>
            <ModelGallery photos={model.photos}/>
        </div>
      )}

      {/* Details */}
      <div className="mb-8">
        <br/>
        <h2 className="text-2xl font-bold mb-2">Details</h2>
        <br/>
        <p className="text-xl text-gray-300 mb-6">{model.description}</p>
        <br/>
        <p className="text-gray-300 whitespace-pre-line">{model.details}</p>
      </div>

      {/* Software Used */}
      {model.softwareUsed?.length > 0 && (
        <div className="mb-8">
          <h2 className="text-2xl font-bold mb-2">Software Used</h2>
          <ul className="list-disc list-inside text-gray-300">
            {model.softwareUsed.map((software, i) => (
              <li key={i}>{software}</li>
            ))}
          </ul>
        </div>
      )}

      {/* Challenges */}
      {model.challenges?.length > 0 && (
        <div className="mb-8">
          <h2 className="text-2xl font-bold mb-2">Challenges</h2>
          <ul className="list-disc list-inside text-gray-300">
            {model.challenges.map((challenge, i) => (
              <li key={i}>{challenge}</li>
            ))}
          </ul>
        </div>
      )}

      {/* Usage Examples */}
      {model.usageExamples?.length > 0 && (
        <div>
          <h2 className="text-2xl font-bold mb-4">Usage Examples</h2>
          <div className="grid md:grid-cols-2 gap-6">
            {model.usageExamples.map((example, i) => (
              <div key={i} className="bg-gray-800 rounded-lg p-4 shadow">
                <img
                  src={example.image}
                  alt={example.title}
                  className="w-full h-48 object-cover rounded mb-4"
                />
                <h3 className="text-xl font-semibold mb-1">{example.title}</h3>
                <p className="text-gray-300 text-sm">{example.description}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ModelPage;
